// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  OPEN_STORE_DIR_APP: 'https://www.google.com/maps/dir/?api=1&query=',
  OPEN_STORE_DIR_WEB: 'https://maps.google.com/maps?daddr=',
};
